import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {RouterLinks} from "../enums/router-links";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  isLogoutClicked: boolean = false;

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = sessionStorage.getItem('session_token');
    if (token) {
      // Si le token existe, autorise l'accès à la route
      return true;
    } else {
      // Si le token n'existe pas, redirige vers la page de connexion
      this.router.navigate([RouterLinks.Login]);
      return false;
    }
  }

}
